<script setup>
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { authorizeOperations } from '@/api/operations'
  import { validateOperationsCallback } from '@/utils/operations'

  const route = useRoute()
  const error = ref('')
  const busy = ref(false)

  async function connect() {
    busy.value = true
    error.value = ''
    try {
      const { challenge, state } = route.query
      if (
        typeof challenge !== 'string' ||
        !/^[A-Za-z0-9_-]{43}$/.test(challenge) ||
        typeof state !== 'string' ||
        !/^[A-Za-z0-9_-]{32,128}$/.test(state)
      ) {
        throw new Error('登录跳转已失效，请从运营与监控重新进入')
      }
      const configured = process.env.VUE_APP_OPERATIONS_URL
      if (!configured) throw new Error('运营平台入口尚未配置')
      const { data } = await authorizeOperations({ challenge, state })
      window.location.replace(validateOperationsCallback(configured, data.redirectUrl, state))
    } catch (failure) {
      error.value = failure.message || '连接失败，请稍后重试'
    } finally {
      busy.value = false
    }
  }
  onMounted(connect)
</script>

<template>
  <section class="operations-connect">
    <h1>运营与监控</h1>
    <p v-if="busy" role="status">正在连接统一登录…</p>
    <p v-if="error" role="alert">{{ error }}</p>
    <el-button v-if="error" :disabled="busy" type="primary" @click="connect">重新连接</el-button>
  </section>
</template>

<style scoped>
  .operations-connect {
    max-width: 560px;
    margin: 100px auto;
    padding: 40px;
    background: white;
    border-radius: 8px;
  }
  .operations-connect h1 {
    font-size: 24px;
    margin-bottom: 25px;
  }
  .operations-connect p {
    color: #687c76;
    line-height: 1.8;
  }
</style>
